module.exports = __webpack_public_path__ + "img/通过.ab055f8a.svg";